import './Search.scss'
import SearchIcon from '@/shared/components/svgIcons/SearchIcon.jsx'
import { useState } from 'react'

export const Search = ({ value, setFilteredValue }) => {
    const [focused, setFocused] = useState(false)
    return (
        <div className={'Search'}>
            <input
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                placeholder={'Поиск по ключевым словам'}
                value={value}
                onChange={(e) => setFilteredValue(e.target.value)}
                className={'Search'}
            />
            <SearchIcon
                className={'search-icon'}
                color={focused ? '#040404' : '#d3d3d3'}
            />
        </div>
    )
}
